var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { accountDetails } from "../../../../mainDi/webDi";
import { EQTOCIgnoreList } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
export var LoginClientDataMapper = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var clientLoginDataEntity;
    var _a;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                if (data.accs.rstusr && !data.accs.rstpwd) {
                    data.accs.rstpwd = true;
                    data.cnsntLst.push({ name: "rstpwd", accType: data.accTyp, mdtry: true });
                }
                // data.cnsntLst = conList;
                mapConsentList(data.cnsntLst, data.excs);
                if (data.panAadhaarLinked === true) {
                    data.cnsntLst = __spreadArray(__spreadArray([], __read(data.cnsntLst), false), [
                        {
                            accType: "",
                            mdtry: false,
                            name: "PanAadhrLnked",
                        },
                    ], false);
                }
                if (data.kraRegComplete === true) {
                    data.cnsntLst = __spreadArray(__spreadArray([], __read(data.cnsntLst), false), [
                        {
                            accType: "",
                            mdtry: false,
                            name: "KRARegSuccess",
                        },
                    ], false);
                }
                _a = {
                    jwtToken: localStorage.getItem("jwt_token"),
                    cnsntLst: data.cnsntLst,
                    accData: getAccData(data),
                    accTyp: data.accTyp,
                    userID: data.accs.uid,
                    userName: ((_b = data === null || data === void 0 ? void 0 : data.accs) === null || _b === void 0 ? void 0 : _b.eqAccName)
                        ? (_c = data === null || data === void 0 ? void 0 : data.accs) === null || _c === void 0 ? void 0 : _c.eqAccName
                        : (_d = data === null || data === void 0 ? void 0 : data.accs) === null || _d === void 0 ? void 0 : _d.coAccName,
                    emaildId: data.accs.eml,
                    empOrDependent: (_e = data === null || data === void 0 ? void 0 : data.accs) === null || _e === void 0 ? void 0 : _e.empOrDependent,
                    accountCode: data.accTyp == "CO" ? data.accs.coAccID : data.accs.eqAccID
                };
                return [4 /*yield*/, accountDetails.getLoginSrc()];
            case 1:
                _a.lgnSrc = _f.sent();
                return [4 /*yield*/, accountDetails.getCipFlag()];
            case 2:
                clientLoginDataEntity = (_a.isImpersonated = _f.sent(),
                    _a.productsAlias = data === null || data === void 0 ? void 0 : data.productsAlias,
                    _a);
                return [2 /*return*/, clientLoginDataEntity];
        }
    });
}); };
var getAccData = function (data) {
    var _a;
    var accData = {
        accTyp: data.accTyp,
        accs: data.accs,
        userID: data.accs.uid,
        excs: data.excs,
        ordTypes: data.ordTypes.filter(function (y) {
            return !(EQTOCIgnoreList === null || EQTOCIgnoreList === void 0 ? void 0 : EQTOCIgnoreList.includes(y.value));
        }),
        orderSlicingLimit: data.orderSlicingLimit,
        prds: manageProductesData(data.prds, data.productsAlias),
        val: data.val,
        mrgSts: data.mrgSts,
        mtf: (_a = data.mtf) === null || _a === void 0 ? void 0 : _a.sts,
        adhrEQ: {
            stat: data === null || data === void 0 ? void 0 : data.adhrEQ,
            brkCode: data.accs.eqBrkCode,
        },
        adhrCOM: {
            stat: data === null || data === void 0 ? void 0 : data.adhrCOM,
            brkCode: data.accs.coBrk,
        },
        opCnst: data.optCnsts,
        coAccID: data.accs.coAccID,
        eqAccID: data.accs.eqAccID,
        eqRmRt: data.accs.eqRmRt,
        eqAccName: data.accs.eqAccName,
        coAccName: data.accs.coAccName,
        prfId: data.accs.prfId,
        dfPrdsMTF: data.dfPrdsMTF,
        productsAlias: data.productsAlias,
        dfPrds: data.dfPrds,
        wtspCnsnt: data.accs.wtspCnsnt,
        panAadhaarLinked: data.panAadhaarLinked,
        kraRegComplete: data.kraRegComplete,
        prefAccTyp: data.prefAccTyp,
        panAadhaarSeededStatus: (data === null || data === void 0 ? void 0 : data.panAadhaarSeededStatus) || [],
        panAdhrList: (data === null || data === void 0 ? void 0 : data.panAadhaarSeededStatus) || [],
        kraRegistrationStatus: data === null || data === void 0 ? void 0 : data.kraRegistrationStatus /*  || [
          {
            pan: "ABCDE1234F",
            sts: "Pending",
            kraAgencyLink: "https://www.google.com/",
            rjRsn: "Pending for KRA Verification",
          },
          {
            pan: "GHIWE4567J",
            sts: "Rejected",
            kraAgencyLink: "https://www.google.com/",
            rjRsn: "Rejected by Protean"
          },
          {
            pan: "BXRPR1383Q",
            sts: "Completed",
            kraAgencyLink: "https://www.google.com/",
            rjRsn: "Verified successfully"
          },
        ] */,
        encrTkn: data.encrTkn ? data.encrTkn : "",
        typ: data.typ,
        srcVendor: data.srcVendor,
        url: data.url,
        logoLnk: data.logoLnk,
    };
    return accData;
};
var manageProductesData = function (productes, productsAlias) {
    var result = productes === null || productes === void 0 ? void 0 : productes.map(function (product) {
        var _a;
        return __assign(__assign({}, product), { prd: (_a = product.prd) === null || _a === void 0 ? void 0 : _a.map(function (prod) {
                var x = productsAlias === null || productsAlias === void 0 ? void 0 : productsAlias.find(function (x) { return x.key === prod.prdVal; });
                return __assign(__assign({}, prod), { prdVal: x === null || x === void 0 ? void 0 : x.key, mainVal: x === null || x === void 0 ? void 0 : x.value });
            }) });
    });
    return result;
};
var ConsentListEnum;
(function (ConsentListEnum) {
    ConsentListEnum["eqstwt"] = "eqstwt";
    ConsentListEnum["costwt"] = "costwt";
    ConsentListEnum["bseMfstwt"] = "bseMfstwt";
    ConsentListEnum["wtsap"] = "wtsap";
    ConsentListEnum["eqIncmDclr"] = "eqIncmDclr";
    ConsentListEnum["accReac"] = "accReact";
    ConsentListEnum["emailMob"] = "emailMob";
    ConsentListEnum["RiskDisclosure"] = "RiskDisclosure";
    ConsentListEnum["invAddress"] = "invAddress";
    ConsentListEnum["invPan"] = "invPan";
    ConsentListEnum["kraReg"] = "kraReg";
    ConsentListEnum["nominee"] = "nominee";
    ConsentListEnum["pnAadhLnk"] = "pnAadhLnk";
    ConsentListEnum["loginFlowConsent"] = "loginFlowConsent";
    ConsentListEnum["vnd"] = "vnd";
    ConsentListEnum["comOpCnst"] = "comOpCnst";
    ConsentListEnum["mtf"] = "mtf";
    ConsentListEnum["rstpwd"] = "rstpwd";
    ConsentListEnum["PanAadhrLnked"] = "PanAadhrLnked";
    ConsentListEnum["KRARegSuccess"] = "KRARegSuccess";
})(ConsentListEnum || (ConsentListEnum = {}));
var mapConsentList = function (cnsList, excs) {
    var filteredConsentList = cnsList.filter(function (list) {
        return Object.values(ConsentListEnum).includes(list.name);
    });
    var newConsentList = filteredConsentList.map(function (list) {
        return mapConsentsObj(list);
    });
    if (excs.includes("NFO") &&
        !cnsList.some(function (obj) { return obj.name === "RiskDisclosure"; })) {
        newConsentList.unshift({
            accType: "",
            mandatory: true,
            name: "RiskDisclosure",
            submitted: false,
        });
    }
    var rstpwdIndex = newConsentList.findIndex(function (csnt) { return csnt.name === "rstpwd"; });
    if (rstpwdIndex !== -1) {
        var rstpwdObject = newConsentList.splice(rstpwdIndex, 1)[0];
        newConsentList.unshift(rstpwdObject);
    }
    localStorage.setItem("consentList", JSON.stringify(newConsentList));
    localStorage.setItem("cnsntLst", JSON.stringify(newConsentList));
};
var mapConsentsObj = function (cnsList) {
    if (cnsList) {
        switch (cnsList.name) {
            case "eqstwt":
                return consObjMapper(cnsList, true);
            case "costwt":
                return consObjMapper(cnsList, true);
            case "bseMfstwt":
                return consObjMapper(cnsList, true);
            case "rstusr":
                return consObjMapper(cnsList, true);
            case "rstpwd":
                return consObjMapper(cnsList, true);
            case "eqIncmDclr":
                return consObjMapper(cnsList, true);
            case "adhrEQ":
                return consObjMapper(cnsList, true);
            case "adhrCOM":
                return consObjMapper(cnsList, true);
            case "mtf":
                return consObjMapper(cnsList, true);
            case "comOpCnst":
                return consObjMapper(cnsList, true);
            case "mrgPopUp":
                return consObjMapper(cnsList, true);
            case "eqRmRt":
                return consObjMapper(cnsList, true);
            case "wtsap":
                return consObjMapper(cnsList, true);
            case "vnd":
                return consObjMapper(cnsList, true);
            case "emailMob":
                return consObjMapper(cnsList, true);
            case "invPan":
                return consObjMapper(cnsList, true);
            case "invName":
                return consObjMapper(cnsList, true);
            case "accReact":
                return consObjMapper(cnsList, true);
            case "invAddress":
                return consObjMapper(cnsList, true);
            case "nominee":
                return consObjMapper(cnsList, true);
            case "pnAadhLnk":
                return consObjMapper(cnsList, true);
            case "loginFlowConsent":
                return consObjMapper(cnsList, true);
            case "RiskDisclosure":
                return consObjMapper(cnsList, true);
            case "kraReg":
                return consObjMapper(cnsList, true);
            case "PanAadhrLnked":
                return consObjMapper(cnsList, true);
            case "KRARegSuccess":
                return consObjMapper(cnsList, true);
        }
    }
};
var consObjMapper = function (consent, mandatory) {
    return {
        accType: consent.accType,
        mandatory: consent.mdtry,
        name: consent.name,
        submitted: false,
    };
};
var conList = [
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "eqstwt",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "costwt",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "bseMfstwt",
    // },
    // {
    //   accType: "",
    //   mdtry: false,
    //   name: "wtsap",
    // },
    // {
    //   accType: "",
    //   mdtry: false,
    //   name: "emailMob",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "RiskDisclosure",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "loginFlowConsent",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "rstpwd",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "kraReg",
    // },
    //SR
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "eqIncmDclr",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "invAddress",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "emailMob",
    // },
    //sr
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "pnAadhLnk",
    // },
    // {
    //   accType: "",
    //   mdtry: true,
    //   name: "accReact",
    // },
    {
        accType: "",
        mdtry: false,
        name: "eqIncmDclr",
    },
];
